export const DROP_DOWN_LIST_LIMIT = 15
